import { SubscriptionInterval } from '@core/models/billing/subscription-interval';
import { SubscriptionPlan } from '@core/models/billing/subscription-plan';
import { SubscriptionTier } from '@core/models/billing/subscription-tier';
import { environment } from '@environments/environment';
import { EnvironmentConfigTierType } from '@environments/environment-config-type';
import { Location } from '@core/models/location/location';

export function getStarterPlanPrice(interval: SubscriptionInterval): number {
    return environment.settings.plans[SubscriptionTier.STARTER][interval].price;
}

export function getPremiumPlanPrice(interval: SubscriptionInterval): number {
    return environment.settings.plans[SubscriptionTier.PREMIUM][interval].price;
}

export function getPremiumPlanPriceForUpsell(): number {
    return getPremiumPlanPrice(SubscriptionInterval.YEAR);
}

export function getStarterPlanId(
    interval: SubscriptionInterval
): SubscriptionPlan {
    return environment.settings.plans[SubscriptionTier.STARTER][interval]
        .planId as SubscriptionPlan;
}

export function getPremiumPlanId(
    interval: SubscriptionInterval
): SubscriptionPlan {
    return environment.settings.plans[SubscriptionTier.PREMIUM][interval]
        .planId as SubscriptionPlan;
}

export function getIHDPlanId(location: Location): SubscriptionPlan {
    if (location?.address?.address?.indexOf('Australia') >= 0) {
        return SubscriptionPlan.LOC_MO_PREM_IHD_AUD;
    } else {
        return SubscriptionPlan.LOC_MO_PREM_IHD;
    }
}

export function getReferralPlanIdForTrial(): SubscriptionPlan {
    return environment.settings.referrals.planId;
}

export function getPremiumPlanIdForTrial(): SubscriptionPlan {
    return getPremiumPlanId(SubscriptionInterval.YEAR);
}

export function getTierConfig(
    tier: SubscriptionTier
): EnvironmentConfigTierType {
    return environment.settings.plans[tier];
}

export function getMonthlyTierConfig(
    tier: SubscriptionTier
): EnvironmentConfigTierType['month'] {
    return getTierConfig(tier)[SubscriptionInterval.MONTH];
}

export function getAnnualTierConfig(
    tier: SubscriptionTier
): EnvironmentConfigTierType['year'] {
    return getTierConfig(tier)[SubscriptionInterval.YEAR];
}

export function isCustomPlan(planId: SubscriptionPlan): boolean {
    const ourPlanIds: SubscriptionPlan[] = Object.values(SubscriptionPlan);
    return !ourPlanIds.includes(planId);
}
